import { AxiosPromise } from 'axios'
import { IUserActivityOverview } from '@src/types/statistics.types'
import { IQuestion } from '@src/types/question.types'
import createAxiosInstance, { createOptimizedAPI } from '.'

export interface IStatisticsApi {
  getUserActivity(userId: number): AxiosPromise<IUserActivityOverview>;
  getTopActivityQuestions(): AxiosPromise<{items: IQuestion[]; total: number }>;
  getTopUpvotedQuestions(): AxiosPromise<{items: IQuestion[]; total: number }>;
}

const api = createAxiosInstance('statistics')

const statisticsApi: IStatisticsApi = {
  getUserActivity(userId) {
    return api.get('network/content', {
      params: {
        user_id: userId
      }
    })
  },
  getTopActivityQuestions() {
    return api.get('network/top-activity-questions', {
      params: {
        limit: 5
      }
    })
  },
  getTopUpvotedQuestions() {
    return api.get('network/top-upvoted-questions', {
      params: {
        limit: 5
      }
    })
  }
}

export default {
  ...statisticsApi,
  ...createOptimizedAPI(statisticsApi)
}
